import store from '$app/store'
import apiConnection from '$app/plugins/api-connection'
import roles from './roles'

function getCookieValue(name) {
  var valueAry = document.cookie.match('(^|[^;]+)\\s*' + name + '\\s*=\\s*([^;]+)');
  return valueAry ? valueAry.pop() : '';
}

const successInterceptor = (response) => {
  if ((response.headers && response.headers['x-reauth'] && response.headers['x-reauth'] === 'reauth') ||
    (store.state.user.name && store.state.user.name !== getCookieValue('VPK-U'))) {
    store.commit('user/reauth');
  }
  store.dispatch('user/checkAuth');
  return response;
};
const errorInterceptor = (error) => {
  if (error.response && error.response.headers && error.response.headers['x-reauth'] && error.response.headers['x-reauth'] === 'reauth') {
    store.commit('user/reauth');
  }
  return Promise.reject(error);
};

apiConnection.addResponseInterceptors(successInterceptor, errorInterceptor);

export default {
  roles,
  checkRoute: (to, from, next) => {
    const nearestWithAuth = to.matched.slice().reverse().find(r => r.meta && r.meta.auth);

    store.dispatch('user/checkAuth').then(function (isAuthenticated) {
      if (nearestWithAuth) {
        if (!isAuthenticated) {
          // Route requires auth, but no authenticated user
          store.commit('user/setAfterLogin', to);
          next({
            path: '/login'
          });
          return;
        }
        const roles = nearestWithAuth.meta.auth.roles;
        if (roles && !store.getters['user/hasRole'](roles)) {
          // Authenticated user, but not authorized
          next({
            path: '/'
          });
          return;
        }
      }
      // Only non-auth routes or Authenticated & Authorized users get here so complete routing
      next();
    });
  },
  checkAuth: (roles) => {
    if (roles === false) {
      return !store.getters['user/isAuthenticated']();
    }
    if (typeof roles === 'string' || typeof roles === 'object') {
      return store.getters['user/hasRole'](roles);
    }
    return store.getters['user/isAuthenticated']();
  },
  checkCookie: () => {
    if (store.getters['user/isAuthenticated']()) {
      apiConnection.get('account/check').then(null, (err) => {
        if (err && err.response && err.response.status === 403) {
          const hardLogout = !(err.response.headers['x-reauth'] && err.response.headers['x-reauth'] === 'reauth');
          store.dispatch('user/logout', hardLogout);
        }
      });
    }
  },
  logout: (hardLogout) => {
    store.dispatch('user/logout', hardLogout);
  }
}
